import React from 'react';
import { Card, Row, Col, Divider } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { pluralize } from '../../utils/utils';

interface AdminCardProps {
  prefix: string;
  title: string;
  description: string;
}

const imageStyle: React.CSSProperties = {
  aspectRatio: '1 / 1',
  objectFit: 'cover',
  width: '200px',
};

const AdminCard: React.FC<AdminCardProps> = ({ prefix, title, description }) => {
  return (
    <Col span={24} xs={24} sm={12} lg={6}>
      <Card
        style={{ height: '100%' }}
        cover={
          <div style={{ padding: '24px', textAlign: 'center' }}>
            <img alt={prefix} src={`/public/images/${prefix}_logo.png`} style={imageStyle} />
          </div>
        }
        actions={[
          <Link key="setting-action" to={`/admin/${pluralize(prefix)}`}>
            <SettingOutlined key="setting" />
          </Link>,
        ]}>
        <Row>
          <Col span={24}>
            <Divider />
          </Col>
          <Col span={24} style={{ height: 80 }}>
            <Card.Meta title={title} description={description} />
          </Col>
        </Row>
      </Card>
    </Col>
  );
};

export const AdminPage: React.FC = () => (
  <Row gutter={[16, 16]} style={{ width: '100%', margin: 0 }}>
    <AdminCard
      prefix="plan-owner"
      title="Plan Owners"
      description="Change or add a new plan owner"
    />
    <AdminCard prefix="plan" title="Plans" description="Change or add a new plan" />
    <AdminCard
      prefix="products-of-configurator"
      title="All products"
      description="Products list from actual configurators"
    />
    {/* <AdminCard 
        prefix="assistant-chat" 
        title="Assistant Chats" 
        description="Chat history" 
    /> */}
    <AdminCard prefix="user" title="Users" description="Manage users" />
    <AdminCard prefix="contractor" title="Contractors" description="Manage contractor profiles" />
    <AdminCard prefix="plans-list" title="Plans List" description="View all plans" />
    {/* <AdminCard 
        prefix="generation" 
        title="Generations" 
        description="Flux generations" 
      /> */}
    <AdminCard prefix="directory" title="Directories" description="Manage directories" />
    <AdminCard prefix="site-visit" title="Site visits" description="Manage site visits" />
  </Row>
);
